import type { IconSvgObject } from './types';

const ListFilterIcon: IconSvgObject = [
  ["path", { d: "M2.99609 5H20.9961", stroke: "currentColor", strokeLinecap: "round", strokeWidth: "1.5", key: "0" }],
  ["path", { d: "M5.99609 12H17.9961", stroke: "currentColor", strokeLinecap: "round", strokeWidth: "1.5", key: "1" }],
  ["path", { d: "M8.99609 19H14.9961", stroke: "currentColor", strokeLinecap: "round", strokeWidth: "1.5", key: "2" }]
];

export default ListFilterIcon;
